export const ATTENDANCE_LOADING = "ATTENDANCE_LOADING";
export const ATTENDANCE_RESET = "ATTENDANCE_RESET";
export const GET_ATTENDANCE = "GET_ATTENDANCE";
export const GET_ATTENDANCE_SUCCESS = "GET_ATTENDANCE_SUCCESS";
export const GET_ATTENDANCE_FAIL = "GET_ATTENDANCE_FAIL";
export const DELETE_ATTENDANCE = "DELETE_ATTENDANCE"
export const DELETE_ATTENDANCE_SUCCESS = "DELETE_ATTENDANCE_SUCCESS"
export const DELETE_ATTENDANCE_FAIL = "DELETE_ATTENDANCE_FAIL"
export const UPDATE_ATTENDANCE = "UPDATE_ATTENDANCE"
export const UPDATE_ATTENDANCE_SUCCESS = "UPDATE_ATTENDANCE_SUCCESS"
export const UPDATE_ATTENDANCE_FAIL = "UPDATE_ATTENDANCE_FAIL"
export const ADD_NEW_ATTENDANCE = "ADD_NEW_ATTENDANCE"
export const ADD_ATTENDANCE_SUCCESS = "ADD_ATTENDANCE_SUCCESS"
export const ADD_ATTENDANCE_FAIL = "ADD_ATTENDANCE_FAIL"